import { Logo } from './Logo.js';

export interface LogoTileProps {
  readonly size?: number;
  readonly className?: string;
}

/**
 * Brand logo tile — always-dark #1a1d23 square with the white Gonka mark
 * from /logo.png. Used on Welcome and Unlock screens as the top branding
 * element. The dark background is intentional — it's the brand tile color
 * (matches dark-theme bg and the PWA app icon).
 */
export function LogoTile({ size = 56, className = '' }: LogoTileProps) {
  return (
    <div
      className={`flex items-center justify-center rounded-[16px] ${className}`}
      style={{ background: '#1a1d23', width: size, height: size }}
    >
      <Logo size={Math.round(size * 0.72)} />
    </div>
  );
}
